module.exports = __webpack_public_path__ + "img/12600.0c28e4ac.jpg";